export function match(param: string) {
  return ["tips-tricks", "product", "engineering", "salesforce"].includes(
    param,
  );
}
